var path = 'app/components/common/forms/templates/ui-select.html';
var html = "<ui-select data-ng-model=\"model[options.key]\" data-required=\"{{to.required}}\" data-disabled=\"{{to.disabled}}\" on-select=\"{{to.onSelect}}\"><ui-select-match placeholder=\"{{to.placeholder}}\" data-allow-clear=\"{{to.allowClear}}\">{{$select.selected[to.labelProp]}}</ui-select-match><ui-select-choices data-repeat=\"{{to.ngOptions}}\"><div ng-bind-html=\"option[to.labelProp] | highlight: $select.search\"></div></ui-select-choices></ui-select>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/ui-select.html
// module id = 195
// module chunks = 0